





























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { IShowGenreObject } from '../../../../../shared/types';
import api from '../../../api';

interface IData {
  genres: IShowGenreObject[],
  liked: boolean;
}

interface IMethods {
  like: (payload: Record<string, string | number>) => void;
  unlike: (payload: Record<string, string | number>) => void;
  interact: () => void;
  goToShow: () => void;
  writeReview: () => void;
}

interface IComputed {
  getSaved: Record<number, boolean>;
  isSaved: boolean;
}

interface IProps {
  id: number;
  name: string;
  released: number;
  image: string;
  padding: boolean;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ShowListItem',

  props: {
    id: {
      type: Number,
      default: 0,
    },

    name: {
      type: String,
      required: true,
    },

    released: {
      type: Number,
      required: false,
      default: -1,
    },

    image: {
      type: String,
      required: true,
    },

    padding: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    liked: false,
    genres: [],
  }),

  async created() {
    this.genres = await api.show.getShowGenres(this.id);
    this.liked = this.isSaved;
  },

  computed: {
    ...mapGetters('shows', [
      'getSaved',
    ]),

    isSaved() {
      return this.id in this.getSaved && this.getSaved[this.id];
    },
  },

  methods: {
    ...mapActions('shows', [
      'like',
      'unlike',
    ]),

    goToShow() {
      this.$router.push(`/show/${this.id}`);
    },

    writeReview() {
      this.$router.push(`/review/${this.id}`);
    },

    interact() {
      this.liked = !this.liked;
      if (!this.liked) {
        this.unlike({
          id: this.id,
        });
      } else {
        this.like({
          id: this.id,
        });
      }
    },
  },
});
